import {useAuthInfo, withRequiredAuthInfo} from "@propelauth/react";
import React, {useContext, useEffect, useState} from "react";
import {useForm} from "react-hook-form";

import {UserContext} from "../../contexts/UserContext";
import {DeveloperProjectConfig, Discoverability} from "../../models/project";
import  {DevBidFormConfig} from "./BidCustomDataConf";

import {Tabs, TabsContent, TabsList, TabsTrigger} from "../ui/tabs"
import {Card, CardHeader, CardContent, CardTitle} from "../ui/card";
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from "../ui/form";
import {ListofRounds_v2} from "./RoundConfigrator_v2";
import {Switch} from "../ui/switch";
import {fetchWithToken, putWithToken} from "../../api/apiBase";
import {useParams} from "react-router-dom";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;

type FormToggleFieldProps = {
    label: string;
    fname: string;
    form: any;
    variant?: string;
    input_type?: string;
    place_holder?: string;
    disabled?: boolean;
    onChange?: (event: string) => void;
};


export function FormToggleField(
    {label, fname, variant, form, disabled,}: FormToggleFieldProps) {
    return (
        <FormField
            control={form.control}
            name={fname}
            render={({field}) => (
                <FormItem>
                    <FormControl className="mr-2 my-2">
                        <Switch
                            disabled={disabled}
                            checked={field.value}
                            onCheckedChange={field.onChange}
                        />
                    </FormControl>
                    <FormLabel className="w-full">{label}</FormLabel>
                </FormItem>
            )}
        />
    );
}

function ProjectGlobals() {
    const userContext = useContext(UserContext);
    const {accessToken} = useAuthInfo();
    const {project_id} = useParams();

    const form = useForm<any>(
        {
            defaultValues: {
                ve: {
                    enabled: true,
                    enable_sharing: true,
                    enable_public: true,
                },
                open: false,
                to_approved: false,
                hidden: false,
                discoverability: Discoverability.FUllyDiscoverable,
                marvin: true,
            }
        }
    );

    useEffect(() => {
        fetchWithToken(`/projects/${project_id}`, accessToken as string)
            .then((data) => {
                // todo (PAvel - server side) - consolidate project.config
            }).catch((err) => {

        })
    }, [project_id])

    // const [] = form.watch([]);
    const [toggleDisabled, setToggleDisabled ] = useState(true)

    useEffect(() => {
        const subscription = form.watch((value, { name }) => {
            if (name === 'hidden') {
                if (!value.hidden) {
                    form.setValue('to_approved', false);
                    form.setValue('open', false); 
                    setToggleDisabled(true)
                } else {
                    form.setValue('to_approved', true);
                    form.setValue('open', true);
                    setToggleDisabled(false)
                }
            }
        });
        return () => subscription.unsubscribe();
    },[form])

    const onSave = (data: DeveloperProjectConfig) => {
        console.log('Save:', data)
        putWithToken(`/projects/${project_id}/config`,
            JSON.stringify(data),
            accessToken as string)
            .then((data) => {

            }).catch((err) => {
                console.log(JSON.stringify(err))
        })

    }

    if (userContext?.company_type === "builder") {
        return <div>You do not have permission to be here! </div>
    }

    return <div className={"container"}>
        <br/>
        <Card>
            <CardHeader className="flex columns-2 justify-between">
                <CardTitle>Project Visibility</CardTitle>
            </CardHeader>
            <CardContent>
                <Form {...form} >
                    <form onSubmit={form.handleSubmit(onSave)}>
                    <div className="relative w-full"><button className="absolute bottom-5 right-0">Save</button></div>
                        <FormToggleField
                            label={"Hidden - Invited Bidders Only "}
                            fname={"hidden"} variant={"checkbox"} form={form}/>
                        <FormToggleField
                            label={"Visible to Previously Approved Bidders"}
                            fname={"to_approved"} variant={"checkbox"} form={form} disabled={toggleDisabled}/>
                        <FormToggleField
                            label={"Fully Discoverable to Verified Bidders"}
                            fname={"open"} variant={"checkbox"} form={form} disabled={toggleDisabled}/>
                        <FormToggleField
                            label={"MarvinAI (Marvin Active Instigation)"}
                            fname={"marvin"} variant={"checkbox"} form={form}/>
                    </form>
                </Form>
            </CardContent>
        </Card>
        <br/>
    </div>
}


function ProjectConfig() {
    return <Tabs defaultValue="bid_rounds">
        <TabsList>
            <TabsTrigger value="bid_rounds">Rounds</TabsTrigger>
            <TabsTrigger value="bid_setup">Bid Template</TabsTrigger>
            <TabsTrigger value="visibility">Project</TabsTrigger>
        </TabsList>

        <TabsContent value="bid_rounds"> <ListofRounds_v2/></TabsContent>
        <TabsContent value="bid_setup"><DevBidFormConfig/></TabsContent>
          <TabsContent value="visibility"><ProjectGlobals/></TabsContent>
    </Tabs>
}


export default withRequiredAuthInfo(ProjectConfig);
